import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const day = v => (v ? new Date(v).toLocaleDateString() : "—");

export const PaymentHistory = () => {
  const { getToken } = useAuth();
  const [rows, setRows] = useState(null);
  useEffect(() => { (async () => { const r = await axios.get(`${API}/me/payments`, { headers: { Authorization: `Bearer ${await getToken()}` } }); setRows(r.data); })().catch(() => setRows([])); }, [getToken]);
  return <div className="history" data-testid="payment-history">
    <div className="panel-head"><span>PAYMENT HISTORY</span><span>{rows ? `${rows.length} ORDERS` : ""}</span></div>
    {rows === null ? <p className="admin-empty">Loading orders...</p> : rows.length === 0 ? <p className="admin-empty" data-testid="payment-history-empty">No payments found for your verified email yet.</p> :
      <div className="table-wrap"><table className="admin-table"><thead><tr><th>Reference</th><th>Asset</th><th>Submitted</th><th>Status</th><th>Approved</th></tr></thead><tbody>
        {rows.map(p => <tr key={p.order_reference} data-testid={`history-row-${p.order_reference}`}><td><code>{p.order_reference}</code></td><td>{p.currency}<small>{p.network}</small></td><td>{day(p.created_at)}</td>
          <td><span className={`review-status status-${p.status}`} data-testid={`history-status-${p.order_reference}`}>{p.status.replace(/_/g, " ")}</span></td>
          <td>{p.status === "approved" ? day(p.reviewed_at) : "—"}{p.membership_expires_at && <small>+30d → {day(p.membership_expires_at)}</small>}</td></tr>)}
      </tbody></table></div>}
  </div>;
};
